<template>
    <div v-if="!GetWallet.Restricted">
        <CRow>
            <div v-if="GetWallet.PageLoad" class="load-container load1">
                            <div class="loader">Loading...</div>
                        </div>
            <CCol sm="12">
                <!-- <b-card no-body> -->
                    <!-- <b-tabs card> -->
    

            <!-- <b-tab title="Special Offer"> -->
                     <CRow>
                    <CCol lg="12">
                        <transition name="fade">
                            <CCard>
                                <CCardHeader>
                                    <strong> Create Manual ERP Order </strong>

                                </CCardHeader>
                                <CCardBody>

                                <CRow>
                                    <CCol lg="4">
                                        <CInput type="text" autocomplete="text" maxlength='16' prepend="Order Id" v-model="GetWallet.DataModel.Data.orderId" />
                                    </CCol>
                                    
                                </CRow>
                                
                                   <!-- <CCol lg="6">
                                    <div class="mb-3" v-if="GetWallet.DataModel.UIData.GenericInputCount==0">

                                        <input class="form-control" id="formFile" @change="importExcel" type="file">
                                    </div>
                                    </CCol> -->
                                    
                                    <div class="mb-3" v-if="GetWallet.DataModel.UIData.GenericInputCount!=0">
                                        <div class="isa_success">
                              
                                            <CIcon name="cil-check-circle" /> <span class="iconLabel">Total Number of record(s) uploaded - {{GetWallet.DataModel.UIData.GenericInputCount}}</span></div>
                                    </div>
                            
                                    <div class="form-actions" v-if="GetWallet.ErrorInfo[0].ErrorMessage!=null">
                                        <div class="isa_error">
                                            <CIcon name="cil-x-circle" /><span class="iconLabel">{{GetWallet.ErrorInfo[0].ErrorMessage}}</span></div>
                                    </div>
                                    <CCol lg="6">
                                    <div class="form-actions" >
                                        <CButton size="sm" @click="CreateManualERPorder()" color="primary">
                                            <CIcon name="cil-check-circle" /> Create</CButton> &nbsp;
                                        <CButton size="sm" @click="clearForm()" color="danger">
                                            <CIcon name="cil-ban" /> Cancel!</CButton>
                                    </div>
                                </CCol>
                                  
                               </CCardBody>
                            </CCard>
                        </transition>
                        <!-- <div v-if="GetWallet.PageLoad" class="load-container load1">
                            <div class="loader">Loading...</div>
                        </div> -->
                    </CCol>

                </CRow>
            <!-- </b-tab> -->


            <!-- </b-tabs> -->
        <!-- </b-card> -->
            </CCol>
        </CRow>
    </div>
    </template>
    
    <script>
    import axios from "axios";
    import * as xlsx from "xlsx";
    
    export default {
        name: 'Forms',
        data() {
            return {
                GetWallet: {
                    PageType: "Master",
                    PageLoad: false,
                    Restricted:false,
                    DataModel: {
                        Data: {
                           
                            orderId :null,

                        },
                        UIData: {
                            downloadData: [],
                            inprogressCount: 0,

                            Reference: null,
                            Processcount: 0,
                            PostListData: [],
                            result: [],
                            finalResult: [],
                            LoadedFileName: "",
                            Panel: null,
                            PanelIsActive:null,
                            ShowProductInfo: false,
                            CalculatedPrice: 0,
                            IsPriceFieldEditable: true,
                            IsGMCProduct: false,
                            ScrapInfo: [],
                            GenericInputCount: 0,
                            QueryString: "",
                            FileName: "Asin",
                            categoryValue:null,
                            BrandName:null,

                        },
                    },
                
                    PageCurrentState: "Default",
                    SessionInfo: {
                        SessionTimeout: false,
                        AuthToken: "",
                        SessionID: "",
                        PageInfo: {
                            userId: 0,
                        },
                    },
                    ValidationInfo: {},
                    ErrorInfo: [{
                        ErrorID: 1,
                        ErrorName: "",
                        ErrorMessage: null,
                    }, ],
                   
                },
            }
        },
        methods: {

     


        CreateManualERPorder() {
            let vm = this;
            vm.GetWallet.PageLoad = true;
            let token = localStorage.getItem("token")
            try {
                axios({
                    method: "POST",
                    url: "graphql",
                    data: {
                        query:`mutation AddOrderDetailsInERP($orderId: String) {
                            addOrderDetailsInERP(OrderId: $orderId)
                            }`,
                variables: {
                    orderId:vm.GetWallet.DataModel.Data.orderId,
                    
                     }
                    },
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                        "Authorization": `Bearer ${token}`
                    }
                }).then(response => {
                       
                    if (response.data.data.addOrderDetailsInERP != undefined && response.data.data.addOrderDetailsInERP != null) {
                        vm.GetWallet.PageLoad = false;
                        vm.GetWallet.DataModel.Data.result = response.data.data.addOrderDetailsInERP;
                        vm.clearForm();
                        vm.$toaster.success("Successfully Added ");
                    } else if (response.data.errors.length > 0) {
                        vm.GetWallet.PageLoad = false;
                        var error_data = "";
                        for (var i = 0; i < response.data.errors.length; i++) {
                            error_data = error_data + response.data.errors[i].message + "\n";
                        }
                        vm.$toaster.error(error_data);
                    }
                }).catch(error => {
                    console.log(error);
                    vm.$toaster.error(error);
                    vm.GetWallet.PageLoad = false;
                });
            } catch (error) {
                console.error(error);
                vm.$toaster.error(error);
                vm.GetWallet.PageLoad = false;
            }
        },



           
            clearForm() {
                try {
                   
                    this.GetWallet.DataModel.Data.orderId=null;
                    

                    

                    document.getElementById('formFile').value = null;
                } catch (ex) {
                    console.log(ex);
                }
            },
    
          
    
        }
    }
    </script>
    